// extracted by mini-css-extract-plugin
export default {"premiumApps":"styles_premiumApps__cQmmS","container":"styles_container__Zvu27","textYellow":"styles_textYellow__bM7c-"};